import { Icons } from "..";

type SpinnerProps = {
    size?: number
};
export const Spinner: React.FC<SpinnerProps> = (props) => {
    return <Icons.Spinner className="animate-spin text-muted-body-text" size={props.size} />
}